const sliderSwiper = new Swiper(".slider .swiper-container", {
  direction: 'horizontal',
  loop: true,
  pagination: {
    el: ".slider .swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".slider .swiper-button-next",
    prevEl: ".slider .swiper-button-prev",
  },
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 10,

  breakpoints: {
    749: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    }
});